import { createContext } from 'react';

const FeatureFlagsContext = createContext();

export const { Provider, Consumer } = FeatureFlagsContext;

export default FeatureFlagsContext;
